import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription, switchMap } from 'rxjs';

import { UsersTabsEnum } from './users-tabs.enum';
import { InvitesService } from './services';

@Component({
  selector: 'tablesready-account-users',
  templateUrl: './users.component.html',
  providers: [InvitesService],
})
export class AccountUsersComponent implements OnInit, OnDestroy {
  tabs = [UsersTabsEnum.users, UsersTabsEnum.invites];
  tabValues = UsersTabsEnum;
  activeTab: string;
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly invitesService: InvitesService,
  ) {
  }

  ngOnInit(): void {
    this.activeTab = UsersTabsEnum.users;

    const invitesSubscription = this.invitesService.load()
      .pipe(switchMap(() => this.invitesService.listenToChanges()))
      .subscribe();
    this.subscriptions.add(invitesSubscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onChangeTab(tab: string): void {
    this.activeTab = tab;
  }
}
